import CssBaseline from "@mui/material/CssBaseline";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Fragment, useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
// includes
import { common, types } from "helpers";
import InnerHeader from "./innerHeader";

const InnerLayout = (props) => {
  // props
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = common.getPath(location.pathname);
  const isMobile = useMediaQuery("(max-width: 991.98px)", { noSsr: true });

  // state
  const [isAuth] = useState(common.checkAuth());
  const [open, setOpen] = useState(true);
  const [showSubIndex, setShowSubIndex] = useState(null);
  const [permission] = useState(common.getUserPermission());

  const handleDrawer = () => {
    setOpen((prev) => !prev);
  };

  const closeDrawer = () => {
    if (isMobile) {
      setOpen(false);
    }
  };

  // effect
  useEffect(() => {
    if (!isAuth) {
      localStorage.clear();
      navigate("/login");
    }
  }, [isAuth, navigate]);

  // Start closed on mobile; keep desktop sidebar open by default
  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  // Close mobile drawer on route change
  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, [location.pathname, isMobile]);

  // Prevent background scroll while mobile drawer is open
  useEffect(() => {
    if (isMobile && open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobile, open]);

  const toggleSubMenu = (index) => {
    setShowSubIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  // On mobile, open = drawer visible; on desktop, open = expanded (not icon-only)
  const sidebarClass = [
    "sidebar-nav-wrap",
    !open ? "toggle" : "",
    isMobile && open ? "mobile-open" : "",
    isMobile && !open ? "mobile-closed" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const contentClass = [
    "admin-content-wrap",
    isMobile ? "pl-mobile" : !open ? "pl-toggle" : "pl-max",
  ]
    .filter(Boolean)
    .join(" ");

  // render
  return (
    isAuth && (
      <Fragment>
        <InnerHeader handleDrawer={handleDrawer} open={open} isMobile={isMobile} />
        <div className="admin-wrap">
          <CssBaseline />
          {isMobile && open && (
            <div
              className="sidebar-backdrop"
              onClick={closeDrawer}
              aria-hidden="true"
            />
          )}
          <aside className={sidebarClass}>
            <ul className="sb-nav">
              {types.menus.map(
                (i, k) =>
                  permission?.includes(i.roleKey) && (
                    <Fragment key={k}>
                      <li
                        className={
                          pathname === i.menuKey ? "active" : "in-active"
                        }
                      >
                        {i.subtitle1 ? (
                          <div
                            className="main-menu"
                            onClick={() => toggleSubMenu(k)}
                          >
                            <img src={common.loadImg(i.icon)} alt={i.name} />{" "}
                            <span>{i.name}</span>
                            <img
                              src={common.loadImg("down-arrow.svg")}
                              alt=""
                              className="sub-menu-arrow"
                            />
                          </div>
                        ) : (
                          <Link to={i.url} onClick={closeDrawer}>
                            <div>
                              <img src={common.loadImg(i.icon)} alt={i.name} />{" "}
                              <span>{i.name}</span>
                            </div>
                          </Link>
                        )}
                      </li>
                      {i.subtitle1 && showSubIndex === k && (
                        <div className="submenu-wrap">
                          {permission?.includes(i.roleKey1) && (
                            <li
                              className={
                                pathname === i.menuKey1
                                  ? "active sub-menu"
                                  : "in-active sub-menu "
                              }
                            >
                              <Link to={i.url} onClick={closeDrawer}>
                                <div className="sub-nav-item">
                                  <img
                                    src={common.loadImg(i.icon1)}
                                    alt={i.name}
                                  />
                                  <span>{i.subtitle1} </span>
                                </div>
                              </Link>{" "}
                            </li>
                          )}
                          {permission?.includes(i.roleKey2) && (
                            <li
                              className={
                                pathname === i.menuKey2
                                  ? "active sub-menu"
                                  : "in-active sub-menu "
                              }
                            >
                              <Link
                                to={i.subtitle2 ? i.suburl2 : "/"}
                                onClick={closeDrawer}
                              >
                                <div className="sub-nav-item">
                                  <img
                                    src={common.loadImg(i.icon2)}
                                    alt={i.name}
                                  />
                                  <span>{i.subtitle2}</span>
                                </div>
                              </Link>
                            </li>
                          )}
                          {i.subtitle3 && (
                            <>
                              {permission?.includes(i.roleKey3) && (
                                <li
                                  className={
                                    pathname === i.menuKey3
                                      ? "active sub-menu"
                                      : "in-active sub-menu "
                                  }
                                >
                                  <Link
                                    to={i.subtitle3 ? i.suburl3 : "/"}
                                    onClick={closeDrawer}
                                  >
                                    <div className="sub-nav-item">
                                      <img
                                        src={common.loadImg(i.icon3)}
                                        alt={i.name}
                                      />
                                      <span>{i.subtitle3}</span>
                                    </div>
                                  </Link>
                                </li>
                              )}
                            </>
                          )}
                          {i.subtitle4 && (
                            <>
                              {permission?.includes(i.roleKey4) && (
                                <li
                                  className={
                                    pathname === i.menuKey4
                                      ? "active sub-menu"
                                      : "in-active sub-menu "
                                  }
                                >
                                  <Link
                                    to={i.subtitle4 ? i.suburl4 : "/"}
                                    onClick={closeDrawer}
                                  >
                                    <div className="sub-nav-item">
                                      <img
                                        src={common.loadImg(i.icon4)}
                                        alt={i.name}
                                      />
                                      <span>{i.subtitle4}</span>
                                    </div>
                                  </Link>
                                </li>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </Fragment>
                  )
              )}
            </ul>
          </aside>
          <div className={contentClass}>
            <Outlet {...props} />
          </div>
        </div>
      </Fragment>
    )
  );
};

export default InnerLayout;
